import React from 'react';
import { usePageVisibility } from './libraries/usePageVisibility';

const PageVisibilityHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  usePageVisibility();
  return <>{children}</>;
};

export default PageVisibilityHandler;